/* 旧品牌灯泡尺寸页选车器（snippets/auxito-brand-finder.liquid，运营 2026-10-08）。
   三个下拉列全站车型目录（AuxitoVehicleUtils，与页头选车器、01 同一份）；Make 预选本页品牌，Year 先只列该品牌有数据的年份。
   确认：进这台车的 06 灯泡尺寸页并定位所选年份（运营 2026-10-10）；06 清单里没有这台车时进旧版车型首页。 */
(function () {
  'use strict';
  var root = document.querySelector('[data-brand-finder]');
  if (!root) return;
  var ySel = root.querySelector('[data-bf-year]');
  var mSel = root.querySelector('[data-bf-make]');
  var dSel = root.querySelector('[data-bf-model]');
  var go = root.querySelector('[data-bf-go]');
  var msg = root.querySelector('[data-bf-msg]');
  var pageMake = root.getAttribute('data-make') || '';
  var flat = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
  var vu = function () { return window.AuxitoVehicleUtils || null; };
  var cat = null;
  var modelSeq = 0;

  function setOptions(sel, values, label, keep) {
    sel.replaceChildren();
    var blank = document.createElement('option');
    blank.value = '';
    blank.textContent = label;
    sel.appendChild(blank);
    values.forEach(function (item) {
      var o = document.createElement('option');
      o.value = item.value;
      o.textContent = item.text || item.value;
      sel.appendChild(o);
    });
    var hit = values.filter(function (item) { return flat(item.value) === flat(keep); })[0];
    sel.value = hit ? hit.value : '';
  }
  function makesOf(year) {
    var u = vu();
    return (u.getCaseInsensitivePropertyValue(cat.makesByYear, year) || []);
  }
  function allYears() {
    return (cat.years || []).map(String).filter(function (y) { return /^\d{4}$/.test(y); }).sort(function (a, b) { return b - a; });
  }
  function catMake(year, make) {
    var list = year ? makesOf(year) : [];
    if (!year) allYears().forEach(function (y) { list = list.concat(makesOf(y)); });
    return list.filter(function (m) { return flat(m) === flat(make); })[0] || '';
  }
  function renderYears(keep) {
    var make = mSel.value;
    var years = allYears().filter(function (y) { return !make || makesOf(y).some(function (m) { return flat(m) === flat(make); }); });
    setOptions(ySel, years.map(function (y) { return { value: y }; }), 'Year', keep);
  }
  function renderMakes(keep) {
    var seen = {};
    var year = ySel.value;
    (year ? [year] : allYears()).forEach(function (y) { makesOf(y).forEach(function (m) { if (!seen[flat(m)]) seen[flat(m)] = m; }); });
    var makes = Object.keys(seen).map(function (k) { return seen[k]; }).sort(function (a, b) { return a.localeCompare(b); });
    setOptions(mSel, makes.map(function (m) { return { value: m }; }), 'Make', keep);
  }
  function renderModels(keep) {
    var seq = ++modelSeq;
    var year = ySel.value;
    var make = mSel.value;
    if (!year || !make) { setOptions(dSel, [], 'Model', ''); dSel.disabled = !make; go.disabled = false; return Promise.resolve(); }
    /* 新年份 / 品牌的车型列表加载完之前，先清掉旧车型并禁用确认，避免提交「新年份 + 旧车型」（PR #55 第四轮审查） */
    setOptions(dSel, [], 'Model', '');
    dSel.disabled = true;
    go.disabled = true;
    return vu().getYearVehicleData(year).then(function (data) {
      if (seq !== modelSeq) return;
      /* 目录里写作 Silverado 2500 Hd：显示成 HD，值保留目录原文 */
      setOptions(dSel, vu().getAvailableModels(data, make).map(function (m) { return { value: m, text: m.replace(/\bHd\b/g, 'HD') }; }), 'Model', keep);
    }).catch(function () {
      if (seq === modelSeq) setOptions(dSel, [], 'Model', '');
    }).then(function () {
      if (seq === modelSeq) { dSel.disabled = false; go.disabled = false; }
    });
  }

  function init() {
    if (!vu()) return;
    vu().getVehicleData().then(function (data) {
      cat = data;
      /* 预选本页品牌：按目录写法匹配（如 INFINITI / Mercedes-Benz）；目录里没有这个品牌时不预选 */
      renderMakes(catMake('', pageMake));
      renderYears('');
      renderModels('');
    }).catch(function () { /* 目录读不到：保持服务端输出的初始状态，确认时提示 */ });
  }

  ySel.addEventListener('change', function () { if (!cat) return; msg.hidden = true; renderMakes(mSel.value); renderModels(dSel.value); });
  mSel.addEventListener('change', function () { if (!cat) return; msg.hidden = true; renderYears(ySel.value); renderModels(''); });
  dSel.addEventListener('change', function () { msg.hidden = true; });
  go.addEventListener('click', function () {
    if (go.getAttribute('aria-busy') === 'true') return; /* 已确认、正在查表跳转：不重复提交（也避免重复上报，PR #55 埋点第七轮审查）；往返缓存恢复时下面的 pageshow 会解除 */
    var v = { year: ySel.value, make: mSel.value, model: dSel.value };
    if (!v.year || !v.make || !v.model) { msg.hidden = false; (v.year ? (v.make ? dSel : mSel) : ySel).focus(); return; }
    go.setAttribute('aria-busy', 'true');
    try { window.AuxitoTrack && window.AuxitoTrack.vehicleSelected('brand_finder', v.year, v.make, v.model); } catch (e) {} /* 车型页埋点：全站选车也上报（assets/auxito-proto-shell-tracking.js） */
    bsgUrl(v).then(function (url) {
      if (url) { window.location.href = url; return; }
      var u = vu();
      window.location.href = u && typeof u.buildVehiclePageUrl === 'function'
        ? u.buildVehiclePageUrl(v, '/pages/vehicle')
        : '/pages/vehicle?' + new URLSearchParams(v).toString();
    });
  });
  // 浏览器返回（往返缓存恢复页面）时去掉跳转前加的 aria-busy
  window.addEventListener('pageshow', function (event) { if (event.persisted) go.removeAttribute('aria-busy'); });

  /* 运营 2026-10-10：Bulb Size 类选车进 06 灯泡尺寸页。按 06 清单（与 06 页选车卡同一份）找这台车的页面：
     条目 [handle, 品牌, 显示车型, 年份[], 年份段, 车型库品牌, 车型库车型[]]，按车型库写法匹配。
     「品牌-车型」网址对外恢复了旧版内容（运营 9-28），与车型页链 06 一样带 view=bulb-size-guide-v2 显示新版并定位年份；
     年份开头的网址本身就是新版。save=1：目标页按自己的车型库原文存进全站车型。 */
  function bsgUrl(v) {
    var src = root.getAttribute('data-directory');
    if (!src) return Promise.resolve('');
    return fetch(src, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
      var y = Number(v.year);
      var p = (d.pages || []).filter(function (e) {
        return flat(e[5]) === flat(v.make) && (e[6] || []).some(function (m) { return flat(m) === flat(v.model); }) && (e[3] || []).indexOf(y) >= 0;
      })[0];
      if (!p) return '';
      var q = new URLSearchParams({ year: v.year, model: p[2], save: '1' });
      if (!/^\d/.test(p[0])) q.set('view', 'bulb-size-guide-v2');
      return '/pages/' + p[0] + '?' + q.toString();
    }).catch(function () { return ''; });
  }

  if (vu()) init();
  else window.addEventListener('load', init, { once: true });
})();
